import axios from "axios"

function getStudentBrief({ id }, {}, params) {
    return axios.get(`api/students/${id}/brief`, { params })
}

function regenerateStudentBrief({ id }, data) {
    return axios.post(`api/students/${id}/brief/regenerate`, data)
}

function getStudentHealth({ id }) {
    return axios.get(`api/students/${id}/health`)
}

export const studentBriefService = {
    getStudentBrief,
    regenerateStudentBrief,
    getStudentHealth,
}
